// 首先获取到 产品的 变体的 库存数据

// 监听 option的点击事件，自动出发 change事件，获取到当前选中的 option的值，和 option的名称

// 根据 option的名称，和值，去之前获取的 变体库存数据中，找到对应的数据，拿到库存数量，和 预设的 库存预警值 进行对比
// 如果 库存数量 小于等于 库存预警值，就在页面上 显示一个 库存紧张的提示
// 如果 库存数量 大于 库存预警值，就隐藏 库存紧张的提示



// 对于 option的点击之后，应该 自动选中这个 option，和 之前的 选中状态进行切换

// 还要考虑到 组合选项的情况，就是说 当一个 option被选中之后，可能会影响到其他 option的 可选状态，比如说 某个选项的 某个值被选中之后，可能会导致 另一个选项的 某个值 不可选了，这时候也需要在页面上进行相应的提示，比如说 禁用这个不可选的值，或者是 显示一个提示信息，告诉用户为什么这个值不可选了。


// 初始化 根据当前选中的option 判断出 是否有些 option 不可选 ，不可选的应该加 css类
// option点击后 需要 判断出其他的 选项是否有不可选的
// 

var optionPicker = {
    hasContent: false,
    currentVariantId: window.myCustomSaveVariantId || null,
    option1SelectedValue: null,
    option2SelectedValue: null,
    option3SelectedValue: null,
    variantsData: null, // 存储变体数据
    inventoryWarningThreshold: 5, // 库存预警值，可以根据需要调整
    currentInventory: null, // 当前选中变体的库存数量
    inventoryVariantMap: {}, // 存储变体ID与库存数量的映射
    currentVariant: null, // 当前选中的变体对象
    optionConfig: null, // 产品选项的配置数据
}

document.addEventListener('DOMContentLoaded', () => {
    initOptionPicker();
    checkOptionsDisable();
    updateAllComboOptionsUI();
    initOptionClickFn();
    console.log('optionPicker', optionPicker);
});

const initOptionPicker = () => {
    optionPicker.currentVariantId = window.myCustomSaveVariantId || null;
    optionPicker.currentVariant = window.current_variant || null;
    optionPicker.option1SelectedValue = window.current_variant?.option1 || null;
    optionPicker.option2SelectedValue = window.current_variant?.option2 || null;
    optionPicker.option3SelectedValue = window.current_variant?.option3 || null;

    optionPicker.variantsData = window.myCustomProdSaveObj.variants || [];
    optionPicker.inventoryVariantMap = window.myCustomProdSaveObj.save_variant_inventory_quantity_obj || {};
    optionPicker.currentInventory = optionPicker.inventoryVariantMap[optionPicker.currentVariantId] || null;

    optionPicker.optionConfig = window.myProdOptionConfig || null;
    optionPicker.hasContent = optionPicker.optionConfig && optionPicker.optionConfig.hasCombo || false;

    // Shopify 变体的 option 名称数组(按 option1/2/3 顺序)，用于把配置顺序映射到真实 option 位置
    optionPicker.shopifyOptions = window.myCustomProdSaveObj?.options || [];


}

// 配置里的选项顺序可能与 Shopify 变体的 option 顺序(option1/2/3)不一致，
// 用选项 title 匹配出真实的 Shopify option 位置；匹配不到时兜底用配置顺序下标(行为等同旧逻辑)
const getRealOptionIndex = (title, fallbackIdx) => {
    const idx = (optionPicker.shopifyOptions || []).indexOf(title);
    return idx >= 0 ? idx : fallbackIdx;
}
const checkOptionCanBeSelected = (optionIndex, optionValue) => {
    // 根据当前选中的option值，判断其他option的值是否可选
    return optionPicker.variantsData.some(variant => {
        return (optionIndex === '0' ? variant.option1 === optionValue : variant.option1 === optionPicker.option1SelectedValue) &&
            (optionIndex === '1' ? variant.option2 === optionValue : variant.option2 === optionPicker.option2SelectedValue) &&
            (optionIndex === '2' ? variant.option3 === optionValue : variant.option3 === optionPicker.option3SelectedValue) &&
            (optionPicker.inventoryVariantMap[variant.id] > 0 || variant.available); // 库存大于0，或允许超卖(Shopify available 为 true，即使库存<=0)的变体才可选
    });
}
const checkOptionsDisable = () => {
    document.querySelectorAll('.my-variantselect-option-value').forEach(optionValueEl => {
        const optionValue = optionValueEl.getAttribute('data-option-value');
        const optionIndex =  optionValueEl.closest('.my-variantselect-optionitem').getAttribute('data-option-index') || 0;
        
        if (checkOptionCanBeSelected(optionIndex, optionValue)) {
            optionValueEl.classList.remove('myoption-disabled');
            optionValueEl.removeAttribute('disabled');
        } else {
            optionValueEl.classList.add('myoption-disabled');
            optionValueEl.setAttribute('disabled', true);
        }
    });
}

const initOptionClickFn = () => {
    document.querySelectorAll('.my-variantselect-option-value').forEach(optionValueEl => {
        optionValueEl.addEventListener('click', (e) => {
            
            const optionValue = e.currentTarget.getAttribute('data-option-value');
            // 获取当前元素的 父级或祖先元素上 my-variantselect-optionitem 存在 data-option-index属性的值
            const optionIndex =  e.currentTarget.closest('.my-variantselect-optionitem').getAttribute('data-option-index') || 0;

            console.log('optionValue', optionValue);
            console.log('optionIndex', optionIndex);

            // 已选中则跳过
            const selectedValues = [optionPicker.option1SelectedValue, optionPicker.option2SelectedValue, optionPicker.option3SelectedValue];
            if (selectedValues[parseInt(optionIndex)] === optionValue) return;

            // 更新选中的option值
            if (optionIndex === '0') {
                optionPicker.option1SelectedValue = optionValue;
            } else if (optionIndex === '1') {
                optionPicker.option2SelectedValue = optionValue;
            } else if (optionIndex === '2') {
                optionPicker.option3SelectedValue = optionValue;
            }

            // 根据选中的option值，找到对应的变体
            const selectedVariant = optionPicker.variantsData.find(variant => {
                return variant.option1 === optionPicker.option1SelectedValue &&
                    variant.option2 === optionPicker.option2SelectedValue &&
                    variant.option3 === optionPicker.option3SelectedValue;
            });
            console.log('selectedVariant', selectedVariant);
            if (selectedVariant) {
                optionPicker.currentVariantId = selectedVariant.id;
                optionPicker.currentInventory = optionPicker.inventoryVariantMap[selectedVariant.id] || null;
                optionPicker.currentVariant = selectedVariant;

                // 更新地址栏 variant 参数
                const url = new URL(window.location.href);
                url.searchParams.set('variant', selectedVariant.id);
                window.history.replaceState({}, '', url.toString());

                // 更新页面UI
                updateSelectedOptionUI(optionIndex, optionValue);

                // 更新内容物
                updateAllComboOptionsUI();

                // 数据的一些变化

                // 检查某些选项是否需要被禁用
                checkOptionsDisable();


                // 暴露出option的变化，可以让其他模块监听到这个变化，事件名称为 myOptionChange，暴露的数据包括 当前选中的option值，和当前选中的变体ID，以及当前选中变体的库存数量
                const eventDetail = {
                    option1: optionPicker.option1SelectedValue,
                    option2: optionPicker.option2SelectedValue,
                    option3: optionPicker.option3SelectedValue,
                    variantId: optionPicker.currentVariantId,
                    inventory: optionPicker.currentInventory,
                }
                const myOptionChangeEvent = new CustomEvent('myOptionChange', { detail: eventDetail });
                document.dispatchEvent(myOptionChangeEvent);
                
            }
        });
    });
}

const updateSelectedOptionUI = (optionIndex, optionValue) => {
    // 更新选中状态的UI，比如说给选中的option加一个选中样式，或者是显示一个选中图标
    document.querySelectorAll('.my-variantselect-option-value').forEach(optionValueEl => {
        const optionValue = optionValueEl.getAttribute('data-option-value');
        const optionIndex =  optionValueEl.closest('.my-variantselect-optionitem').getAttribute('data-option-index') || 0;

        if (optionIndex === '0' && optionValue === optionPicker.option1SelectedValue) {
            optionValueEl.classList.add('myoption-selected');
        } else if (optionIndex === '1' && optionValue === optionPicker.option2SelectedValue) {
            optionValueEl.classList.add('myoption-selected');
        } else if (optionIndex === '2' && optionValue === optionPicker.option3SelectedValue) {
            optionValueEl.classList.add('myoption-selected');
        } else {
            optionValueEl.classList.remove('myoption-selected');
        }
    });
}

// 根据 combo选项 和 当前其他选项的选中值，找到对应的变体
const findVariantForComboItem = (comboOptionIndex, comboItemName) => {
    const idx = parseInt(comboOptionIndex);
    return optionPicker.variantsData.find(variant => {
        const opts = [variant.option1, variant.option2, variant.option3];
        for (let i = 0; i < 3; i++) {
            if (i === idx) {
                if (opts[i] !== comboItemName) return false;
            } else {
                const selectedVal = [optionPicker.option1SelectedValue, optionPicker.option2SelectedValue, optionPicker.option3SelectedValue][i];
                if (selectedVal && opts[i] !== selectedVal) return false;
            }
        }
        return true;
    });
}

// 把元字段里的日元原值(如3000)格式化成带 ¥ 和千分位的字符串，与 liquid 的 | money 保持一致
const formatComboYenMoney = (yen) => {
    const num = Number(yen);
    if (!Number.isFinite(num)) return '';
    const cents = num * 100; // formatMoney/money 过滤器接收的是最小货币单位
    if (window.vndCurrency && typeof vndCurrency.formatMoney === 'function' && window.vndTheme && vndTheme.m_f) {
        return vndCurrency.formatMoney(cents, vndTheme.m_f);
    }
    // 兜底：日元格式 ¥3,000
    return '¥' + Math.round(num).toLocaleString('ja-JP');
};

// Shopify 变体价格已是最小货币单位(分)，直接格式化
const formatVariantMoney = (cents) => {
    const num = Number(cents);
    if (!Number.isFinite(num)) return '';
    if (window.vndCurrency && typeof vndCurrency.formatMoney === 'function' && window.vndTheme && vndTheme.m_f) {
        return vndCurrency.formatMoney(num, vndTheme.m_f);
    }
    return '¥' + Math.round(num / 100).toLocaleString('ja-JP');
};

// 更新所有 combo 类型选项的 UI（图片、价格、折扣、内容物）
const updateAllComboOptionsUI = () => {
    if (!optionPicker.optionConfig?.options?.length) return;

    const selectedValues = [optionPicker.option1SelectedValue, optionPicker.option2SelectedValue, optionPicker.option3SelectedValue];

    optionPicker.optionConfig.options.forEach((optionConfigItem, optionIdx) => {
        if (optionConfigItem.type !== 'combo') return;

        // 用 title 映射到真实 Shopify option 位置，避免配置顺序与变体 option 顺序不一致时错位
        const realIdx = getRealOptionIndex(optionConfigItem.title, optionIdx);
        const optionIndex = realIdx.toString();
        const selectedValue = selectedValues[realIdx];

        optionConfigItem.values.forEach(comboItem => {
            const optionValueEl = document.querySelector(
                `.my-variantselect-optionitem[data-option-index="${optionIndex}"] .my-variantselect-option-value[data-option-value="${CSS.escape(comboItem.name)}"]`
            );
            if (!optionValueEl) return;

            const matchingVariant = findVariantForComboItem(optionIndex, comboItem.name);
            const variantId = matchingVariant?.id?.toString();
            const variantConfig = variantId ? comboItem.variantConfig?.[variantId] : null;

            const imgEl = optionValueEl.querySelector('.my-variantselect-option-combovalue-image > img');
            if (imgEl) imgEl.setAttribute('src', variantConfig?.imgUrl || '');

            const variantPriceCents = Number(matchingVariant?.price) || 0;
            const variantCompareCents = Number(matchingVariant?.compare_at_price) || 0;
            const priceEl = optionValueEl.querySelector('.my-variantselect-option-combovalue-infoprice-price');
            if (priceEl) priceEl.innerHTML = variantPriceCents ? formatVariantMoney(variantPriceCents) : '';

            const dcConfig = window.myProdDCConfigVariantObj?.[variantId];
            const couponKey = dcConfig?.direct?.counponkey || '';
            const hasCoupon = couponKey !== '';
            const showComprice = variantCompareCents > variantPriceCents && !hasCoupon;
            const showLabel = hasCoupon;

            const descEl = optionValueEl.querySelector('.my-variantselect-option-combovalue-infoprice-desc');
            if (descEl) {
                descEl.style.display = showLabel ? '' : 'none';
                descEl.innerText = showLabel ? '\u5024\u5f15\u304d\u524d\u4fa1\u683c' : '';
            }

            const compPriceEl = optionValueEl.querySelector('.my-variantselect-option-combovalue-infoprice-comprice');
            if (compPriceEl) {
                if (showComprice) {
                    compPriceEl.style.display = '';
                    compPriceEl.innerHTML = '<span class="my-variantselect-option-combovalue-infoprice-comprice-value">' + formatVariantMoney(variantCompareCents) + '</span>';
                } else {
                    compPriceEl.style.display = 'none';
                    compPriceEl.innerHTML = '';
                }
            }

            const dcEl = optionValueEl.querySelector('.my-variantselect-option-combovalue-dc');
            if (dcEl) dcEl.innerText = couponKey;

            // 先清除已有的内容物
            optionValueEl.querySelector('.my-variantselect-option-combovalue-content')?.remove();

            // 只有选中项才显示内容物
            if (comboItem.name === selectedValue && variantConfig?.content?.length) {
                let itemHtml = '';
                variantConfig.content.forEach(contentItem => {
                    itemHtml += `<div class="my-variantselect-option-combovalue-content-item">
                        ${parseInt(contentItem.num) > 1 ? `<div class="my-variantselect-option-combovalue-content-item-num">x${contentItem.num}</div>` : ''}
                        <img src="${contentItem.imgurl}" alt="" width="60" height="60" loading="lazy" decoding="async" fetchpriority="low" />
                    </div>`;
                });
                const contentHtml = `<div class="my-variantselect-option-combovalue-content">
                    <div class="my-variantselect-option-combovalue-content-title">内容物：</div>
                    <div class="my-variantselect-option-combovalue-content-items">${itemHtml}</div>
                </div>`;
                optionValueEl.querySelector('.my-variantselect-option-combovalue-cont')?.insertAdjacentHTML('beforeend', contentHtml);
            }
        });
    });
}
